import { render, staticRenderFns } from "./lb-column.vue?vue&type=template&id=47e9ebc5"
import script from "./lb-column.vue?vue&type=script&lang=js"
export * from "./lb-column.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Test-OA/jh-oa-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('47e9ebc5')) {
      api.createRecord('47e9ebc5', component.options)
    } else {
      api.reload('47e9ebc5', component.options)
    }
    module.hot.accept("./lb-column.vue?vue&type=template&id=47e9ebc5", function () {
      api.rerender('47e9ebc5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/lb-table/lb-column.vue"
export default component.exports